import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=0e59d28d"
import script from "./ServiceTable.vue?vue&type=script&lang=ts"
export * from "./ServiceTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports